import React from 'react';

import { callbackPhone } from '../../../site-config';
import PartLazyImage from '../../part-lazy-image';

import IconCheckmarkBig from './assets/icon-checkmark-big.svg';
import ImageZeroPressure from './assets/image-zero-pressure.webp';

import styles from './part-estimation-form.module.scss';

export default function PartEstimationForm() {
  return (
    <div className={styles.formBox}>
      <form className={styles.form}>
        <div className={styles.stepContainer_current}>
          <div className={styles.step4__iconDone}>
            <IconCheckmarkBig />
          </div>
          <p className={styles.step4__title}>Thank you for your request!</p>
          <p className={styles.step4__paragpaph}>
            One of our team members will contact you shortly to schedule
            <br className="visibleOnDesktopAndTablet" />
            {' '}
            your Free Estimate and a 25% Discount.
          </p>
          <p className={styles.step4__paragpaph}>We will be calling you from this number:</p>
          <p className={styles.step4__phoneNumber}>{callbackPhone}</p>
          <p className={styles.step4__paragpaph}>...so please make sure you pick up.</p>
        </div>

        <div className={styles.step1__imageZeroPressure}>
          <PartLazyImage
            src={ImageZeroPressure}
            alt="pass the test to get a discount"
          />
        </div>
      </form>
    </div>
  );
}
